<template>
    <div class="section-box">
        <div class="customer-list">
            <el-row class="customer-row-bg">
                <el-col :span="20" style="text-align: left; display: flex; align-items: center">
                    <el-form :inline="true" label-width="100px" label-position="left">
                        <el-form-item label="B2b权限:">
                            <el-select v-model="form.IsFreeToB2b" placeholder="请选择">
                                <el-option v-for="item in isFreeToB2bOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="对接人:">
                            <el-select v-model="form.AdminUserId" placeholder="请选择">
                                <el-option v-for="item in JobAdminUserArray" :key="item.UserId" :label="item.RealName"
                                    :value="item.UserId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="发单时间：">
                            <el-date-picker size="" v-model="searchTime" type="daterange" format="yyyy-MM-dd"
                                :picker-options="pickerOptions" value-format="yyyy-MM-dd" range-separator="—"
                                start-placeholder="开始" end-placeholder="结束" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="4">
                    <el-form inline label-width="90px" label-position="left" style="text-align: right">
                        <el-form-item>
                            <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="medium" icon="el-icon-download" @click="exportExcel">导出</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>

        <!-- 列表 -->
        <!-- B2B统计数据 -->
        <el-table :data="tableData" :border="true" v-loading="listLoading" stripe style="width: 100%;margin-top: 5px;">
            <el-table-column prop="Title" label="类别" width="150">
                <template slot-scope="scope">
                    <span @click="viewSendJob(6)">
                        {{ scope.row.Title }}
                    </span>
                </template>
            </el-table-column>

            <el-table-column prop="Value" label="结果" width="150">
                <template slot-scope="scope">
                    <span @click="viewJobMatchComplete()" :title="scope.row.Content">
                        {{ scope.row.Value }}
                    </span>
                </template>
            </el-table-column>
        </el-table>

    </div>
</template>
<script>
import {
    getReceiverJobStatistice,
} from "@/service/jobStatistics";
import {
    getTakeOverUserList,    //获取负责人
} from "@/service/job";
export default {
    data() {
        return {
            searchTime: '',
            listLoading: false,
            form: {
                // PageNum: 1,
                // PageSize: 10,
                // CompanyId: "",
                // CompanyName: "", //企业名称

                IsFreeToB2b: 0,
                AdminUserId: 0,
                StartDate: "",
                EndDate: "",
            },
            total: 0, //总条数
            tableData: [],
            statisticalData: null,

            isFreeToB2bOptions: [
                {
                    value: 0,
                    label: '全部'
                },
                {
                    value: 1,
                    label: '有'
                },
                {
                    value: 2,
                    label: '无'
                },
            ],
            JobAdminUserArray: [{ "UserId": 0, "RealName": "选择对接人" }],
            pickerOptions: {
                shortcuts: [{
                    text: '当月',
                    onClick(picker) {
                        const now = new Date();
                        var today = new Date(now.toLocaleDateString());

                        var year = now.getFullYear();
                        var month = now.getMonth() + 1;
                        var str = year + '-' + month + "-1";
                        var nmonth_first = new Date(str);

                        picker.$emit('pick', [nmonth_first, today]);
                    }
                }, {
                    text: '当天',
                    onClick(picker) {
                        const now = new Date();
                        var today = new Date(now.toLocaleDateString());

                        // var year=now.getFullYear();
                        // var month=now.getMonth()+1;
                        // var str=year+'-'+month+"-1";
                        // var nmonth_first=new Date(str);

                        picker.$emit('pick', [today, today]);
                    }
                }]
            },

        };
    },
    created() {
        this.tableData = [];

        this.initSearchTime();
        this.getTakeOverUserListFun();
        this.handleSearch();
    },

    methods: {
          initSearchTime() {
            const now = new Date();
            var today = new Date(now.toLocaleDateString());

            var year_today = today.getFullYear();
            var month_today = today.getMonth() + 1;
            var day_today = today.getDate();
            var today_str = year_today + '-' + month_today + '-' + day_today;
            console.log('today_str:' + today_str);

            var year = now.getFullYear();
            var month = now.getMonth() + 1;
            var start = year + '-' + month + "-1";
            console.log('start:' + start);
            var nmonth_first = new Date(start);
            // console.log('end 时间:' + nmonth_first);
            // this.searchTime = [nmonth_first, today];
            this.searchTime = [start, today_str];
        },
        // 查询
        handleSearch() {
            this.handleCurrentChange(1);
        },
        // 重置
        handleReset() {
            this.initSearchTime();
            this.form.IsFreeToB2b = 0;
            this.form.AdminUserId = 0;
            this.tableData = [];
            this.handleSearch();
        },
        handleSizeChange(val) {
            if (this.listLoading) return;
            this.form.PageNum = 1;
            this.form.PageSize = val;
            this.getReceiverJobStatistice();
        },
        handleCurrentChange(val) {
            if (this.listLoading) return;
            this.form.PageNum = val;
            this.getReceiverJobStatistice();
        },
        //获取edi工单列表
        async getReceiverJobStatistice() {
            //   console.info('this.form.UserCode :' + this.form.UserCode);

            this.listLoading = true;
            if (this.searchTime && this.searchTime.length) {
                this.form.StartDate = this.searchTime[0];
                this.form.EndDate = this.searchTime[1];
            }
            else {
                this.form.StartDate = "";
                this.form.EndDate = "";
            }
            let data = {
                IsFreeToB2b: this.form.IsFreeToB2b,
                AdminUserId: this.form.AdminUserId
            };
            if (this.form.StartDate != "") data.StartDate = this.form.StartDate;
            if (this.form.EndDate != "") data.EndDate = this.form.EndDate;

            console.log("data:" + JSON.stringify(data));

            let res = await getReceiverJobStatistice(data);
            this.listLoading = false;
            if (res.Result != 1) {
                return this.$message.error(res.Message);
            }
            this.tableData = res.Data.TableData;
            this.statisticalData = res.Data.StatisticalData
        },

        exportExcel() {
            if (this.searchTime && this.searchTime.length) {
                this.form.StartDate = this.searchTime[0];
                this.form.EndDate = this.searchTime[1];
            }
            else {
                this.form.StartDate = "";
                this.form.EndDate = "";
            }
            let data = {
             IsFreeToB2b: this.form.IsFreeToB2b,
                AdminUserId: this.form.AdminUserId
            };
            if (this.form.StartDate != "") data.StartDate = this.form.StartDate;
            if (this.form.EndDate != "") data.EndDate = this.form.EndDate;

            let url =
                process.env.NODE_ENV == "development"
                    ? "/api4"
                    : process.env.VUE_APP_API4;
            window.open(
                url +
                "/api/JobStatistics/ExportReceiverJob?" +
                this.parseJsonURL(data)
            );
        },
        parseJsonURL(json) {
            if (!json) return "";
            if (typeof json == "string") return json;
            return this.cleanArray(
                Object.keys(json).map(function (key) {
                    if (json[key] === undefined) return "";
                    return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
                })
            ).join("&");
        },
        cleanArray(actual) {
            var newArray = [];
            for (var i = 0; i < actual.length; i++) {
                if (actual[i]) {
                    newArray.push(actual[i]);
                }
            }
            return newArray;
        },
        removeSpaces(str) {
            return str.replace(/\s+/g, '');
        },

        // 获取负责人列表
        getTakeOverUserListFun() {
            getTakeOverUserList().then(res => {
                this.JobAdminUserArray = [{ "UserId": 0, "RealName": "选择对接人" }, ...res.Data];
            });
        },

    },
};
</script>
<style lang="scss" scoped>
.customer-list {
    position: relative;

    .next-button {
        position: absolute;
        right: 0;
        top: -56px;
    }
}

.customer-row-bg {
    padding: 20px 14px;
    background-color: #f9fafc;
    display: flex;
    align-items: center;

    .el-form-item {
        margin-bottom: 0 !important;
    }

    .selected {
        color: #409eff;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
    }
}

/deep/ .el-table th.el-table__cell {
    background: #F5F7FA;
}
</style>